export default "__VITE_ASSET__CDaRrFmp__"